module.exports = __webpack_public_path__ + "img/ring_y_i_1_null.63d1e4d4.png";